import axiosAuth from '../../axiosMain';

async function store(data) {
  try {
    let response = await axiosAuth.post('/skip_answer', data);
    return response.data.data;
  } catch (e) {}
}

export default {
  store,
};
